<template>
    <b-overlay :show="loading" rounded="sm">

        <div class="mb-4">

            <div class="h5">
                Anotações

                <span v-b-tooltip.hover title="Clique e arraste na imagem abaixo para inserir as anotações da redação">
                    <i class="fas fa-xs fa-info-circle"></i>
                </span>
            </div>

            <canvas
                ref="essay"
                class="essay"
                :class="{'essay-edit': canEdit, 'essay-no-edit': !canEdit}"
                @click="eventClick"
                @mousedown="eventMouseDown"
                @mouseup="eventMouseUp"
            ></canvas>
        </div>

        <div class="annotation bg-light border-top shadow-sm" v-if="annotation_select && !canEdit">
            <div class="container">
                <b>
                    Comentário da Marcação
                </b>
                <p>
                    {{ annotation_select.msg }}
                </p>
            </div>
        </div>

        <div class="annotation bg-light border-top shadow-sm" v-if="annotation_select && canEdit">
            <div class="container">
                <div class="row">
                    <div class="col-sm-7">
                        <div class="">
                            <b-textarea
                                placeholder="Comente o erro detalhado neste campo ..."
                                rows="2"
                                v-model="annotation_select.msg"
                                @change="onChangeMsg"
                                @blur="onChangeMsg">
                            </b-textarea>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="">
                            <select
                                class="custom-select"
                                v-model="annotation_select.color"
                                @change="onChangeColor">

                                <option value="rgba(212, 255, 50, 0.40)">Cor Amarela</option>
                                <option value="rgba(255, 255, 0, 0.40)">Cor Amarela 2</option>
                                <option value="rgba(173, 216, 230, 0.40)">Cor Azul</option>
                                <option value="rgba(255, 64, 64, 0.40)">Cor Vermelha</option>
                                <option value="rgba(69, 139, 116, 0.40)">Cor Marinho</option>
                                <option value="rgba(255, 127, 0, 0.40)">Cor Laranja</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <button type="button" class="btn btn-block btn-primary" @click="destroyAnnotation(annotation_select.id)">Remover</button>
                    </div>
                </div>
            </div>
        </div>

    </b-overlay>
</template>

<script>
export default {
    props: ['essay'],
    data() {
        return {
            loading: false,
            canvasEl: null,
            context: null,
            width: null,
            height: null,
            posX: null,
            posY: null,
            posFinalX: null,
            posFinalY: null,
            annotations: [],
            annotation_select: null,
            annotation_key: null,
            color: 'rgba(212, 255, 50, 0.40)',
            selectX: 0,
            selectY: 0,
            edit: false,
            canEdit: true,
            isMobile: false,
        }
    },
    mounted() {

        // Canvas
        this.canvasEl = this.$refs.essay;

        // Get Context in 2D
        this.context = this.canvasEl.getContext('2d');
    },
    created() {

        if (this.essay.status === 'OKAY' || this.essay.status === 'WAIT' || this.essay.status === 'BLOCK')
            this.canEdit = false

        // Load
        this.load()
    },
    methods: {

        // Load Essay Annotations
        load(showLoading = true) {
            if (showLoading) {
                this.loading = true;
            }
            axios.get('/teacher/annotations/' + this.essay.id)
                .then(async (result) => {
                    const response = result.data.data
                    this.annotations = await response.annotations;
                    await this.$emit('annotations', this.annotations)
                    await this.createContextInitial();
                    await this.searchAnnotation();
                })
                .finally(() => {
                    if (showLoading) {
                        this.loading = false
                    }
                })
        },

        // Add Annotation
        addAnnotation(annotation) {
            axios.post('/teacher/annotations/' + this.essay.id, annotation)
                .then(async (result) => {
                    const response = result.data.data

                    // Load
                    await this.load(false);

                    // Save Message
                    this.$toast.success('A marcação foi adicionada :)', {
                        duration: 1500
                    })
                })
        },

        // Update Annotation
        updateAnnotation(id, annotation, showToast = true) {
            this.edit = true;
            axios.put('/teacher/annotations/' + id, annotation)
                .then((result) => {
                    // Load
                    this.load(false);

                    // Save Message
                    if (showToast) {
                        this.$toast.success('A marcação foi salva :)', {
                            duration: 1500
                        })
                    }
                })
                .finally(() => {
                    this.edit = false;
                })
        },

        // Remove Annotation
        destroyAnnotation(id) {
            this.edit = true;
            axios.delete('/teacher/annotations/' + id)
                .then((result) => {

                    // Save Message
                    this.$toast.success('A marcação foi removida :)', {
                        duration: 1500
                    })

                    // Remove Selection
                    this.annotation_select = null;
                    this.annotation_key = null;

                    // Load
                    this.load(false);
                })
                .finally(() => {
                    this.edit = false;
                })
        },

        // Create Context
        createContextInitial() {
            const imageObj = new Image();
            this.loading = true;

            imageObj.onload = () => {
                this.width = imageObj.width;
                this.height = imageObj.height;
                this.canvasEl.width = this.width;
                this.canvasEl.height = this.height;
                this.context.drawImage(imageObj, 0, 0, this.width,  this.height);
                this.loading = false;

                // Load Annotations
                this.loadAnnotations();
            };

            // Load Image
            imageObj.src = this.essay.preview;
        },

        // Load Annotations
        loadAnnotations() {
            this.annotations.forEach((value, key) => {

                this.context.beginPath();
                this.context.rect(value.posX, value.posY, value.finalX, value.finalY);
                this.context.fillStyle = value.color;

                if (value.edit) {
                    this.context.lineWidth = 2;
                    this.context.strokeStyle = '#333';
                    this.context.stroke();
                }

                this.context.fill();

            });
        },

        // Event Click
        eventClick(event) {
            const rect = this.canvasEl.getBoundingClientRect();

            const scaleX = this.canvasEl.width / rect.width;
            const scaleY = this.canvasEl.height / rect.height;

            const posX = (event.clientX - rect.left) * scaleX;
            const posY = (event.clientY - rect.top) * scaleY;

            this.selectX = posX;
            this.selectY = posY;

            this.searchAnnotation();
        },

        // Event Mouse Down
        eventMouseDown(event) {
            if (this.canEdit) {
                const rect = this.canvasEl.getBoundingClientRect();

                const scaleX = this.canvasEl.width / rect.width;
                const scaleY = this.canvasEl.height / rect.height;

                this.posX = (event.clientX - rect.left) * scaleX;
                this.posY = (event.clientY - rect.top) * scaleY;
            }
        },

        // Event Mouse Up
        async eventMouseUp(event) {
            if (this.canEdit) {
                const rect = this.canvasEl.getBoundingClientRect();

                const scaleX = this.canvasEl.width / rect.width;
                const scaleY = this.canvasEl.height / rect.height;

                this.posFinalX = (event.clientX - rect.left) * scaleX;
                this.posFinalY = (event.clientY - rect.top) * scaleY;

                const finalX = this.posFinalX - this.posX;
                const finalY = this.posFinalY - this.posY;

                if ((finalX > 15 && finalY > 15) && !this.loading && !this.edit) {

                    let annotation = {
                        posX: this.posX,
                        posY: this.posY,
                        finalX: finalX,
                        finalY: finalY,
                        edit: false,
                        msg: '',
                        color: this.color
                    };

                    this.annotations.push(annotation);

                    this.context.beginPath();
                    this.context.rect(this.posX, this.posY, finalX, finalY);
                    this.context.fillStyle = this.color;
                    this.context.fill();

                    // Mark
                    this.selectX = this.posX + 1;
                    this.selectY = this.posY + 1;

                    // Search Position
                    await this.searchAnnotation();

                    // Save in Database
                    await this.addAnnotation(annotation);

                }
            }
        },

        // Search Annotation
        async searchAnnotation() {
            const x = this.selectX;
            const y = this.selectY;

            const finds = [];

            this.annotations.forEach((value, key) => {
                if (x >= value.posX && x <= (value.posX + value.finalX) && y >= value.posY && y <= (value.posY + value.finalY)) {
                    // this.annotations[key]['edit'] = true;
                    finds.push(key);
                    this.createContextInitial();
                } else {
                    this.annotations[key]['edit'] = false;
                    this.createContextInitial();
                }
            });

            if (finds.length === 1) {

                this.annotations[finds[0]]['edit'] = true;
                this.annotation_key = finds[0];
                this.annotation_select = this.annotations[finds[0]];

            } else if (finds.length > 1) {

                this.annotations.forEach((value, key) => {
                    this.annotations[key]['edit'] = false;
                });

                let element_drag = finds[0];

                for (let index = 1; index < finds.length; index++) {

                    let key_small = finds[0];

                    const actual = this.annotations[key_small];
                    const valueX = (actual.posX + actual.finalX) - actual.posX;
                    const valueY = (actual.posY + actual.finalY) - actual.posY;

                    const element = finds[index];
                    const valueCompX = (this.annotations[element]['posX'] + this.annotations[element]['finalX']) - this.annotations[element]['posX'];
                    const valueCompY = (this.annotations[element]['posY'] + this.annotations[element]['finalY']) - this.annotations[element]['posY'];

                    if (valueCompX <= valueX && valueCompY <= valueY) {
                        key_small = element;
                        element_drag = element;
                        this.annotations[element]['edit'] = false;
                    } else {
                        this.annotations[element]['edit'] = false;
                    }

                }

                this.annotations[element_drag]['edit'] = true;
                this.annotation_key = element_drag;
                this.annotation_select = await this.annotations[element_drag];
                await this.createContextInitial();

            } else {
                this.annotation_select = null;
                await this.createContextInitial();
            }
        },

        // Change Color
        onChangeColor(event) {
            this.annotations[this.annotation_key].color = event.target.value;
            this.color = event.target.value;

            // Update
            this.updateAnnotation(this.annotations[this.annotation_key].id, this.annotations[this.annotation_key]);

        },

        // Change Message
        async onChangeMsg(event) {
            this.annotations[this.annotation_key].msg = await this.annotation_select.msg

            let isToast = false;

            if (event.type === 'blur') {
                isToast = true;
            }

            // Update
            this.updateAnnotation(this.annotations[this.annotation_key].id, this.annotations[this.annotation_key], isToast);
        },

    }
}
</script>

<style scoped>
    .essay {
        cursor: pointer;
        width: 100%;
    }
    .essay-mobile {
    }
    .essay-edit {
        cursor: crosshair;
    }
    .essay-no-edit {
        cursor: pointer;
    }
    .annotation {
        position: fixed;
        bottom: 0;
        left:0;
        background:#F8F8F8;
        width: 100%;
        border-top: 1px solid #EAEAEA;
        padding: 15px 0;
        z-index: 50;
    }
    .annotation-backdrop {
        background: #333;
        opacity: 0.4;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 45;
    }
</style>
